import 'react';
import { get, find } from 'lodash';
import ModalValidateLoadingComponent from "./ModalValidateLoadingComponent";
import BigNumber from "bignumber.js";
import React from "react";
import {Form, Slider} from "antd";
import utils from "../../common/utils";
import consts from "../../consts";

const marks = {
  0: {
    style: {
      color: 'white',
      opacity: 0.8,
    },
    label: <strong>0%</strong>,
  },
  25: {
    style: {
      color: 'white',
      opacity: 0.8,
    },
    label: <strong>25%</strong>,
  },
  50: {
    style: {
      color: 'white',
      opacity: 0.8,
    },
    label: <strong>50%</strong>,
  },
  75: {
    style: {
      color: 'white',
      opacity: 0.8,
    },
    label: <strong>75%</strong>,
  },
  100: {
    style: {
      color: 'white',
      opacity: 0.8,
    },
    label: <strong>100%</strong>,
  }
};


class BaseOrderComponent extends ModalValidateLoadingComponent {
  constructor(props) {
    super(props);
    this.state = {
      ...this.state,
      params: {
        price: this.props.lastPrice || 0,
        amount: 0,
        total: 0,
      },
      slideValue: 0,
    }
  }
  
  componentDidMount() {
    const upperCoin = `${this.props.coin}`.toUpperCase();
    const upperCurrency = `${this.props.currency}`.toUpperCase();
    this.coinSetting = find(this.props.coinSettings || [], (coinSetting) => coinSetting.coin === upperCoin && coinSetting.currency === upperCurrency);
  }
  
  renderSlider = React.memo(({ slideValue }) => {
    return <Form.Item className="mt-medium">
      <Slider
        min={0}
        max={100}
        onChange={this.onSlide}
        marks={marks}
        value={typeof slideValue === 'number' ? slideValue : 0}
        step={1}
      />
    </Form.Item>;
  })
  
  handleMarketChange = (nextProps) => {
    const { mapCurrencyMarkets, coin, currency } = nextProps;
    const upperCoin = `${this.props.coin}`.toUpperCase();
    const upperCurrency = `${this.props.currency}`.toUpperCase();
    this.coinSetting = find(this.props.coinSettings || [], (coinSetting) => coinSetting.coin === upperCoin && coinSetting.currency === upperCurrency);

    const precision = Math.abs(Math.log10(this.coinSetting.precision));
    let lastPrice = new BigNumber(get(mapCurrencyMarkets, [currency, coin, 'last_price'], "")).toFixed(precision);
  
    const params = {...this.state.params, price: `${lastPrice}`, amount: 0, total: 0};
    this.setState({params});
  }
  
  onPriceChange = (price, precision = consts.DEFAULT_PRECISION) => {
    if (price === '') {
      this.setState({params: {...this.state.params, price: '', total: 0}});
      return
    }
    if (new BigNumber(price).isNaN() || new BigNumber(price).dp(precision, BigNumber.ROUND_FLOOR).isEqualTo(this.state.params.price)) {
      this.setState({});
      return
    }

    const total = utils.trimRightZero(new BigNumber(price).times(this.state.params.amount).toFixed(8));
    this.setState({params: {...this.state.params, price, total}});
  }
  
  onAmountChange = (amount, precision = consts.DEFAULT_PRECISION) => {
    if (amount === '') {
      this.setState({params: {...this.state.params, amount: '', total: 0}});
      return
    }
    
    if (new BigNumber(amount).isNaN() || new BigNumber(amount).dp(precision, BigNumber.ROUND_FLOOR).isEqualTo(this.state.params.amount)) {
      this.setState({});
      return
    }

    const total = utils.trimRightZero(new BigNumber(amount).times(this.state.params.price).toFixed(8));
    this.setState({params: {...this.state.params, amount, total}});
  }
  
  onTotalChange = (total, precision = consts.DEFAULT_PRECISION) => {
    if (total === '') {
      this.setState({params: {...this.state.params, total: '', amount: 0}});
      return
    }
    if (new BigNumber(total).isNaN() || new BigNumber(total).dp(precision, BigNumber.ROUND_FLOOR).isEqualTo(this.state.params.total)) {
      this.setState({});
      return
    }

    let amount = 0;
    if (!new BigNumber(this.state.params.price).isZero()) {
      amount = utils.trimRightZero(new BigNumber(total).div(this.state.params.price).toFixed(8));
    }

    this.setState({params: {...this.state.params, total, amount}});
  }
}

export default BaseOrderComponent;
